// This component renders a validation message that is always visible, even if the validation is not met.
// When the validation is met, ie error={false}, the text will be its default color, when it is not
// met, ie error={true}, the text will be `error.main` (some form of red at the moment).

import React from 'react'
import Box from '@mui/material/Box';

export function PersistentErrorMessage({ error = false, children }) {
  return (
    <Box
      component="p"
      sx={{
        color: error ? 'error.main' : 'initial',
        marginBottom: 0,
      }}
    >
    {children}
  </Box>
  )
}
